<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M16.0083 13.1167L13.0583 16.0667C12.9416 16.1834 12.8333 16.4 12.8083 16.5584L12.6499 17.6833C12.5916 18.0917 12.875 18.375 13.2833 18.3167L14.4083 18.1583C14.5666 18.1333 14.7916 18.025 14.9 17.9084L17.8499 14.9584C18.3583 14.45 18.5999 13.8583 17.8499 13.1083C17.1083 12.3667 16.5166 12.6083 16.0083 13.1167Z"
            :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15.5833 13.5416C15.8333 14.4416 16.5332 15.1416 17.4332 15.3916"
            :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color))',
  },
});
</script>